<template>
    <div>
        <Header />
        <div class="homePage">
            <div class="content">
                <!-- 下单须知 -->
                <div class="desc">
                    <div class="desc-title">
                        <img src="../assets/note.png">
                        <span>{{ orderNotice.section_title }}</span>
                    </div>

                    <div class="desc-item" v-for="(item, index) in orderNotice.items" :key="index">
                        <p class="p">
                            <play-circle-filled class="icon" />
                            <span class="title">{{ item.title }}</span>
                            <span class="text">
                                <template v-for="(seg, sIdx) in splitNoticeText(item.text)" :key="sIdx">
                                    <span v-if="seg.highlight">{{ seg.text }}</span>
                                    <template v-else>{{ seg.text }}</template>
                                </template>
                            </span>
                        </p>
                    </div>

                    <div class="contact">
                        <div style="display: flex;">
                            <img src="../assets/phone.png" alt="" style="width: 20px;height: 20px;margin-right: 8px;">
                            <p style="font-weight: bold;font-size: 17px;">{{ orderNotice.contact_title }}</p>
                        </div>

                        <p>{{ orderNotice.contact_intro }}
                            <a :href="`https://t.me/${customer_name}`" target="_blank">
                                <span class="call"><aliwangwang-outlined  class="icon" />{{customer_ser}}</span>
                            </a>
                            <a href="javascript:void(0)" class="meiqia-link" @click.prevent="openMeiqia">
                                <span class="call"><aliwangwang-outlined class="icon" />美洽在线客服</span>
                            </a>
                        </p>

                        <div style="display: flex;">
                            <img src="../assets/waring.png" alt="" style="width: 20px;height: 20px;margin-right: 8px;">
                            <p style="font-weight: bold;color: #e7473c;">{{ orderNotice.contact_warning }}</p>
                        </div>
                    </div>
                </div>

                <!-- 分类 -->
                <div class="list-wrap">
                    <a-row :gutter="[20, 20]" justify="center" class="mobile-padding">
                        <a-col :span="8" v-for="(item, index) in categoryList" :key="index">
                            <div class="item " @click="onCategory(item)">{{ item.text }}</div>
                        </a-col>
                        <a-col style="margin-top:4px;">
                            <a-button type="primary" v-show="isShow" @click="showMore"> <i
                                    class="anticon anticon-search"></i><down-outlined />展示更多分类</a-button>
                            <a-button type="primary" v-show="!isShow" @click="hideMore"><up-outlined />收起分类</a-button>
                        </a-col>
                    </a-row>
                </div>

                <div class="product-wrap">
                    <p class="title">{{ categoryTitle }}</p>

                    <p v-if="!showCategoryData.length" style="color: #999;">暂无数据</p>
                    <a-row v-else :gutter="[20, 20]">
                        <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-for="(item, index) in showCategoryData"
                            :key="index">
                            <div class="item" @click="toDetail(item)">
                                <img :src="item.src" class="img">
                                <div>
                                    <p style="font-weight: bold; font-size: 16px; margin-bottom: 10px;">{{ item.title }}
                                    </p>
                                    <a-space :size="2">
                                        <a-tag color="green">{{ item.sendWay }}</a-tag>
                                        <a-tag color="red">{{ `库存${item.count}` }}</a-tag>
                                        <a-tag color="orange">{{ `销售${item.sell}` }}</a-tag>
                                    </a-space>
                                    <p style="color:#e7473c; font-weight: bold; margin-bottom: 0;margin-top: 8px">{{
                                        `$ ${item.price}`
                                        }}
                                    </p>
                                </div>
                            </div>
                        </a-col>
                    </a-row>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import { readReferralFromSearch, buildReferralQuery } from '../util/deeplink';
import Header from './header.vue';
import Footer from './footer.vue'
import { message } from 'ant-design-vue';
import { getUserByRefer, getHomeCatalog, getOrderNotice } from '../util/api';
import { initMeiqia, showMeiqiaPanel } from '../util/meiqia';

const DEFAULT_ORDER_NOTICE = {
    section_title: '下单须知',
    items: [
        { title: '支付方式：', text: '因支付通道风控，本站仅支持 **USDT** 支付。' },
        { title: '订单时效：', text: '所有商品均可自助下单提货！卡密下单后请在 **三小时内核销完成**！超时问题客服不处理，不接受退款，不接受扯皮！' },
        { title: '支付说明：', text: '所有卡密只接受 **USDT虚拟币（TRC20）付款**，不收人民币！购卡请自备USDT，虚拟币双向匿名。' },
        { title: '商品保障：', text: '本站账号类API类商品均包首登，一经出售去除库存绝无二次出售！' },
    ],
    contact_title: '客服联系方式：',
    contact_intro: '有任何问题请及时联系客服进行对接TG：',
    contact_warning: '注意：本工作室只使用Telegram，微信QQ等其他平台全部为冒充！谨防上当受骗！',
};

export default {
    name: 'HomePage',
    props: {
        msg: String
    },
    components: {
        Header,
        Footer
    },
    data() {
        return {
            isToast:false,
            isShow: true,
            referralCode:"",
            gameGroupId:"",
            customer_ser:"在线客服",
            customer_name:"",
            orderNotice: {
                section_title: DEFAULT_ORDER_NOTICE.section_title,
                items: DEFAULT_ORDER_NOTICE.items.map((it) => ({ ...it })),
                contact_title: DEFAULT_ORDER_NOTICE.contact_title,
                contact_intro: DEFAULT_ORDER_NOTICE.contact_intro,
                contact_warning: DEFAULT_ORDER_NOTICE.contact_warning,
            },
            categoryTitle: '',
            categoryList: [],
            showCategoryData: [],
            defaultCategory: [
                {
                    text: '微信账号批发',
                    data: [
                        { title: '8-15天手工精养实名绑卡带支付', src: require('../assets/wechat.jpg'), sendWay: '自动发货', count: 980, sell: 2367, price: 28.0 },
                        { title: '8-15天手工精养实名绑卡带支付', src: require('../assets/wechat.jpg'), sendWay: '自动发货', count: 980, sell: 2367, price: 0.5 },
                        { title: '8-15天手工精养实名绑卡带支付', src: require('../assets/wechat.jpg'), sendWay: '自动发货', count: 980, sell: 2367, price: 0.5 },
                        { title: '8-15天手工精养实名绑卡带支付', src: require('../assets/wechat.jpg'), sendWay: '自动发货', count: 980, sell: 2367, price: 0.5 },
                        { title: '8-15天手工精养实名绑卡带支付', src: require('../assets/wechat.jpg'), sendWay: '自动发货', count: 980, sell: 2367, price: 0.5 },
                        { title: '8-15天手工精养实名绑卡带支付', src: require('../assets/wechat.jpg'), sendWay: '自动发货', count: 980, sell: 2367, price: 0.5 },
                        { title: '8-15天手工精养实名绑卡带支付', src: require('../assets/wechat.jpg'), sendWay: '自动发货', count: 980, sell: 2367, price: 0.5 },
                        { title: '8-15天手工精养实名绑卡带支付', src: require('../assets/wechat.jpg'), sendWay: '自动发货', count: 980, sell: 2367, price: 0.5 },
                    ]
                },
                {
                    text: 'Telegram专区',
                    data: [
                        { title: '随机国家Telegram账号【自助链接接码上号】', src: require('../assets/product.jpg'), sendWay: '自动发货', count: 980, sell: 2367, price: 0.5 },
                        { title: '随机国家 Telegram账号 【协议号】', src: require('../assets/product.jpg'), sendWay: '自动发货', count: 2712, sell: 3721, price: 0.3 },
                        { title: 'Telegram账号 随机国家 1-2年老号【直登】', src: require('../assets/product.jpg'), sendWay: '自动发货', count: 980, sell: 2367, price: 0.5 },
                        { title: 'TG引流助手(破解永久版)', src: require('../assets/product.jpg'), sendWay: '自动发货', count: 2712, sell: 3721, price: 0.3 },
                        { title: 'Telegram会员x3个月', src: require('../assets/product2.jpg'), sendWay: '自动发货', count: 980, sell: 2367, price: 0.5 },
                        { title: 'Telegram会员x6个月', src: require('../assets/product2.jpg'), sendWay: '自动发货', count: 2712, sell: 3721, price: 0.3 },
                        { title: 'Telegram会员x12个月', src: require('../assets/product2.jpg'), sendWay: '自动发货', count: 980, sell: 2367, price: 0.5 },
                        { title: 'TG引流助手(破解永久版)', src: require('../assets/product.jpg'), sendWay: '自动发货', count: 2712, sell: 3721, price: 0.3 },
                    ]
                },
                {
                    text: '快手专区',
                    data: [
                        { title: '快手满月实名号', src: require('../assets/kuai.jpg'), sendWay: '自动发货', count: 980, sell: 2367, price: 8.0 },
                        { title: '快手满月实名号', src: require('../assets/kuai.jpg'), sendWay: '自动发货', count: 980, sell: 2367, price: 8.0 },
                    ]
                },
                {
                    text: '腾讯QQ/企业QQ',
                    data: [
                        { title: 'QQ号出售【星星直登】（苹果直登）', src: require('../assets/QQimg.jpg'), sendWay: '自动发货', count: 335, sell: 888, price: 2.0 },
                        { title: 'QQ号出售【星星直登】（苹果直登）', src: require('../assets/QQimg.jpg'), sendWay: '自动发货', count: 454, sell: 222, price: 2.0 },
                    ]
                },
                { text: '抖音专区', data: [] },
                {
                    text: '海外苹果ID批发',
                    data: [
                        { title: 'Apple ID（独享账号新号）台湾/韩国/英国/香港/美国/日本', src: require('../assets/appleImg.jpg'), sendWay: '自动发货', count: 645, sell: 637, price: 1.0 },
                        { title: 'Apple ID（独享账号新号）台湾/韩国/英国/香港/美国/日本', src: require('../assets/appleImg.jpg'), sendWay: '自动发货', count: 645, sell: 637, price: 1.0 },
                    ]
                },
                { text: '购物卡核销专区', data: [] },
                { text: 'Facebook账号批发', data: [] },
                { text: 'Tiktok账号批发', data: [] },
            ],
            moreCategory: [
               
            ],
        }
    },
    async mounted() {
        const { referralCode, gameGroupId } = readReferralFromSearch(window.location.search);
        this.referralCode = referralCode;
        this.gameGroupId = gameGroupId;

        // 主页接入美洽：刷新页面会清本地会话并用新 clientId，旧消息不带回
        initMeiqia({ clearHistory: true }).catch((e) => {
            console.warn('[Home] 美洽初始化失败', e);
        });

        try {
            const catalogPromise = getHomeCatalog();
            const noticePromise = getOrderNotice();
            const userPromise = this.referralCode
                ? getUserByRefer(this.referralCode)
                : Promise.resolve(null);

            const [catalogRes, noticeRes, userRes] = await Promise.all([
                catalogPromise,
                noticePromise,
                userPromise,
            ]);

            if (noticeRes?.data) {
                this.applyOrderNotice(noticeRes.data);
            }

            const loadData = catalogRes?.data;
            if (Array.isArray(loadData) && loadData.length > 0) {
                const defaultCategoryArr = loadData.map((cat) => ({
                    text: cat.name,
                    id: cat.id,
                    data: Array.isArray(cat.products) ? cat.products : [],
                }));
                this.defaultCategory = defaultCategoryArr;
                this.categoryList = this.defaultCategory;
                this.categoryTitle = this.defaultCategory[0].text;
                this.showCategoryData = this.defaultCategory[0].data;
            }

            if (userRes?.data) {
                this.customer_ser = userRes.data.firstname;
                this.customer_name = userRes.data.username;
            }
        } catch (e) {
            console.warn('[Home] 接口加载失败，使用本地默认分类数据', e);
        }
    },
    methods: {
        applyOrderNotice(data) {
            if (!data || typeof data !== 'object') return;
            this.orderNotice = {
                section_title: data.section_title || DEFAULT_ORDER_NOTICE.section_title,
                items: Array.isArray(data.items) && data.items.length
                    ? data.items.map((it) => ({
                        title: it.title || '',
                        text: it.text || '',
                    }))
                    : DEFAULT_ORDER_NOTICE.items.map((it) => ({ ...it })),
                contact_title: data.contact_title || DEFAULT_ORDER_NOTICE.contact_title,
                contact_intro: data.contact_intro || DEFAULT_ORDER_NOTICE.contact_intro,
                contact_warning: data.contact_warning || DEFAULT_ORDER_NOTICE.contact_warning,
            };
        },
        /** 将 **高亮** 拆成片段，高亮段用红色 span 渲染 */
        splitNoticeText(text) {
            const src = String(text || '');
            const parts = src.split(/\*\*(.+?)\*\*/g);
            return parts.map((part, idx) => ({
                text: part,
                highlight: idx % 2 === 1,
            })).filter((p) => p.text !== '');
        },
        openMeiqia() {
            const entId = process.env.VUE_APP_MEIQIA_ENT_ID;
            if (!entId) {
                message.warning('美洽客服尚未配置企业 ID');
                return;
            }
            message.loading({ content: '正在打开客服…', key: 'meiqia', duration: 0 });
            initMeiqia({ clearHistory: false })
                .then((ok) => {
                    message.destroy('meiqia');
                    if (!ok) {
                        message.error('美洽客服初始化失败，请刷新后重试');
                        return;
                    }
                    showMeiqiaPanel();
                })
                .catch((e) => {
                    console.error('[Home] openMeiqia', e);
                    message.destroy('meiqia');
                    message.error('美洽客服加载失败');
                });
        },
        showMore() {
            this.isShow = !this.isShow
            this.categoryList = [...this.defaultCategory, ...this.moreCategory]
        },
        hideMore() {
            this.isShow = !this.isShow
            this.categoryList = [...this.defaultCategory]
        },

        // 点击分类展示分类产品
        onCategory(item) {
            if (!item.data.length) {
                message.info('暂无该分类的数据!');
            }
            this.categoryTitle = item.text
            this.showCategoryData = item.data
        },
        toDetail(item) {
            const query = buildReferralQuery(this.referralCode, this.gameGroupId);
            if (item.link_key) {
                query.link_key = item.link_key;
            } else if (item.id != null) {
                query.id = String(item.id);
            } else {
                message.warning('商品信息不完整');
                return;
            }
            this.$router.push({ name: 'Detail', query });
        },
        
        
    }
}
</script>

<style scoped lang="less">
.homePage {
    display: flex;
    justify-content: center;
    height: 100%;
    background-color: #f8f8f8;
}

.content {
    width: 1200px;
    margin-top: 32px;
}

.desc {
    background-color: #fff;
    padding: 20px 20px 24px;
    border-radius: 12px;

    .desc-title {
        height: 56px;
        font-size: 24px;
        font-weight: bold;
        border-bottom: 2px solid #4096ff;
        display: flex;
        align-items: center;
        margin-bottom: 24px;

        img {
            width: 32px;
            height: 32px;
            margin-right: 12px;
        }

        span {
            line-height: 56px;
        }
    }

    .desc-item {
        display: flex;
        align-items: center;
        box-shadow: 4px 4px 9px rgba(159, 186, 220, 0.2);
        border: 1px solid rgba(159, 186, 220, 0.2);
        border-radius: 8px;
        margin-bottom: 12px;
        height: 100%;
        padding: 20px;

        .p {
            margin-bottom: 0;
            line-height: 22px;

            .icon {
                margin-right: 10px;
                font-size: 18px;
                vertical-align: text-bottom;
                color: #4096ff;
            }

        }

        .title {
            color: #4096ff;
            font-weight: bold;
            font-size: 16px;

        }

        .text {
            font-size: 16px;

        }

        .text span {
            color: #e7473c;
            font-weight: bold;
        }
    }

    .contact {
        margin-top: 32px;
        background-color: #FEF6D5;
        padding: 10px 10px 5px;
        border-radius: 10px;

        .call {
            color: #fff;
            cursor: pointer;
            background-color: #6b6bef;
            display: inline-block;
            padding: 6px 16px;
            align-items: center;
            border-radius: 20px;
            font-size: 13px;
            margin-top: 10px;
            margin-right: 10px;

            .icon {
                font-size: 15px;
                margin-right: 6px;
            }
        }

        .meiqia-link {
            margin-left: 4px;
        }
    }
}

.list-wrap {
    margin-top: 40px;

    .item {
        height: 36px;
        width: 100%;
        line-height: 36px;
        text-align: center;
        box-shadow: 2px 2px 4px rgba(159, 186, 220, 0.2);
        border: 1px solid rgba(159, 186, 220, 0.2);
        border-radius: 4px;
        font-size: 14px;
        cursor: pointer;
        background-color: #fff;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0 10px;
    }

    .item:hover {
        background: #F7F9FD;
        color: #4096ff;
    }
}

.product-wrap {
    margin: 40px 0;
    background: #fff;
    border-radius: 12px;
    padding: 20px 20px 24px;

    .title {
        line-height: 50px;
        border-bottom: 1px solid #EDF2FA;
        margin-bottom: 20px;
    }

    .item {
        display: flex;
        align-items: center;
        border-radius: 8px;
        padding: 12px;
        box-shadow: 4px 4px 9px rgba(159, 186, 220, 0.2);
        border: 1px solid rgba(159, 186, 220, 0.2);
        cursor: pointer;

        .img {
            border-radius: 12px;
            height: 78px;
            width: 78px;
            margin-right: 16px;
        }
    }

    .item:hover {
        background: #F7F9FD;

    }

    
}
</style>
